import { useState } from "react";

/** The inline "add a new option" row a select reveals from its "+ Add new …" entry. */
export function AddOptionRow({ placeholder, testId, onAdd }: {
  placeholder: string;
  /** `<testId>-new` (the input) and `<testId>-new-confirm` (the button). */
  testId: string;
  onAdd: (name: string) => void;
}) {
  const [draft, setDraft] = useState("");
  const confirm = () => {
    const name = draft.trim();
    if (name) onAdd(name);
  };
  return (
    <div className="add-option-row" data-testid={`${testId}-add`}>
      <input
        className="input"
        type="text"
        value={draft}
        autoFocus
        aria-label={placeholder}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key !== "Enter") return;
          e.preventDefault();
          confirm();
        }}
        placeholder={placeholder}
        data-testid={`${testId}-new`}
      />
      <button type="button" className="btn btn--sm" onClick={confirm} data-testid={`${testId}-new-confirm`}>
        Add
      </button>
    </div>
  );
}
